import * as yup from 'yup';
import { capitalizeString } from '@shared/helpers/index.ts';
import type { Client } from '@shared/types/cart';
import type { Order } from '@shared/types/shop';
import type { BasketOrder } from '@src/library/models/shop';

export const normalizeCart = (order: BasketOrder) => {
  return {
    id: order.id,
    items: order.items.map((item) => ({
      id: item.id,
      title: item.storageitem.product.title,
      image: item.storageitem.product.promo_image ?? '',
      buyer_price: item.storageitem.product.current_price,
      partner_price: item.storageitem.product.partner_price?.partner_amount,
      partner_reward: item.storageitem.product.partner_price?.partner_reward,
      count: item.count,
      available: item.storageitem.count,
      attributes: item.storageitem.attributevalue.map((value) => ({
        id: value.id,
        type: value.attribute.type,
        title: value.attribute.title,
        value: value.value.code ? value.value.code : value.value.title,
      })),
      attributeIds: item.storageitem.attributevalue.map((value) => value.id),
      storageItem: item.storageitem,
    })),
    itemIds: order.items.map((item) => item.id),
    amount: order.amount,
    promocode: order.promocode,
  };
};

export const normalizeClient = (order: BasketOrder | Order) => {
  const splitName = (name: string | null, part: string) => {
    let nameArr: string[] = [];
    if (!name) {
      return null;
    } else {
      nameArr = name.split(' ');
    }
    let namePart: string | null = null;
    switch (part) {
      case 'last_name':
        namePart = nameArr[0];
        break;
      case 'first_name':
        namePart = nameArr[1];
        break;
      case 'middle_name':
        namePart = nameArr[2];
        break;

      default:
        break;
    }
    return namePart;
  };

  return {
    last_name: splitName(order.full_name, 'last_name'),
    first_name: splitName(order.full_name, 'first_name'),
    middle_name: splitName(order.full_name, 'middle_name'),
    phone: order.phone,
    email: order.email,
  };
};

export const schema = yup
  .object()
  .shape({
    last_name: yup.string().required('Фамилия не заполнена'),
    first_name: yup.string().required('Имя не заполнено'),
    // middle_name: yup.string().required('Отчество не заполнено'),
    phone: yup.string().required('Телефон не указан').min(11, 'Номер указан не полностью'),
    email: yup
      .string()
      .required('E-mail не указан')
      .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i, 'E-mail указан неверно'),
    city: yup.object({
      code: yup.number().required('Город не указан'),
    }),
    pickup_point: yup.object({
      id: yup.string().required('Точка выдачи не указана'),
    }),
  })
  .required();

export const createName = (client: Client, field: string, value: string) => {
  client = { ...client, [field]: value };
  return [
    capitalizeString(client.last_name),
    capitalizeString(client.first_name),
    capitalizeString(client.middle_name),
  ].join(' ');
};
